import styled from 'styled-components'
import { Box, Button } from 'pcln-design-system'
import get from 'lodash/get'

export const BannerContainer = styled(Box)`
  ${(props) => get(props, 'theme.flyQueries.mobile', '')} {
    padding: 0 8px 0 8px;
  }}
`

export const StyledButton = styled(Button)`
  white-space: nowrap;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 132px;
`
